import { render } from "./FormPermissions.vue?vue&type=template&id=45b71b47"
import script from "./FormPermissions.vue?vue&type=script&lang=js"
export * from "./FormPermissions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Route\\Vue\\dashboard-tahsel-metronic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__